import React from 'react';
import { Button } from 'system/atoms';
import { useDrawer } from 'services/drawer/hooks';
import { DrawerComponentType } from 'services/drawer/types';

type Props = {
  jobDescriptionText: string;
  jobDescriptionParsed: any; // Using any here for simplicity, but should be properly typed
  onSave?: (description: string) => void;
};

export const CampaignCreationJobDescriptionButton: React.FC<Props> = ({
  jobDescriptionText,
  jobDescriptionParsed,
  onSave
}) => {
  const { openDrawer } = useDrawer();

  const handleViewJobDescription = () => {
    openDrawer({
      drawerContentType:
        DrawerComponentType.CampaignCreationJobDescriptionHtmlDrawer,
      drawerComponentProps: {
        originalDescription: jobDescriptionText,
        jobDescriptionParsed,
        jobDescriptionText,
        hideCloseIconButton: true,
        onSave: onSave
      }
    });
  };

  return (
    <Button variant="tertiary" onClick={handleViewJobDescription}>
      Job description
    </Button>
  );
};
